/**
 * The computer's own Messages app, with the number and the text already
 * in it — the web twin of the mobile sheet's "Open in Messages".
 *
 * Apple (Messages on a Mac, iPhone, iPad) wants `&body=`, everything else
 * wants `?body=`; getting it wrong drops the whole query without an
 * error, which reads as the message simply not arriving in the thread.
 */
export function smsUrl(phone: string | null | undefined, body: string, apple: boolean): string {
  const separator = apple ? '&' : '?';
  const to = (phone || '').replace(/[^\d+]/g, '');
  return `sms:${to}${separator}body=${encodeURIComponent(body)}`;
}

export function isApple(userAgent: string = navigator.userAgent): boolean {
  return /Mac|iPhone|iPad|iPod/.test(userAgent);
}

/**
 * Hand the link to the operating system and report whether anything took
 * it. A browser cannot ask whether an `sms:` handler exists, and a link
 * nobody handles fails silently — so the only signal is the page losing
 * focus (Messages coming forward, or the browser's "Open Messages?"
 * prompt) within a moment of the click.
 */
export function openSms(url: string, wait = 1500): Promise<boolean> {
  return new Promise((resolve) => {
    let done = false;
    const finish = (opened: boolean) => {
      if (done) return;
      done = true;
      window.removeEventListener('blur', onLeave);
      document.removeEventListener('visibilitychange', onLeave);
      clearTimeout(timer);
      resolve(opened);
    };
    const onLeave = () => finish(true);
    window.addEventListener('blur', onLeave);
    document.addEventListener('visibilitychange', onLeave);
    const timer = setTimeout(() => finish(document.hidden || !document.hasFocus()), wait);
    try {
      window.location.href = url;
    } catch {
      finish(false);
    }
  });
}
